import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemDbName} from '../DB/FormChooseDb.jsx'
import Model from './ModelDbins.mjs'

export const FormItemDbInsName = props => (
    <FormItemBizProp
        Model={Model}
        prop="dbInsName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemIp = props => (
    <FormItemBizProp
        Model={Model}
        prop="dbInsIntranetIp"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseDbins(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemDbName />
            <FormItemDbInsName />
            <FormItemIp />
        </FormChooseDesign>
    )
}
